import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AdminLayout, AuthLayout } from '@/layouts';
import { ROUTES } from '@/constants/routes';

const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);
const UsersPage = lazy(() =>
  import('@/pages/UsersPage').then((m) => ({ default: m.UsersPage })),
);
const LogsPage = lazy(() =>
  import('@/pages/LogsPage').then((m) => ({ default: m.LogsPage })),
);
const StaffPage = lazy(() =>
  import('@/pages/StaffPage').then((m) => ({ default: m.StaffPage })),
);
const LoginPage = lazy(() =>
  import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage })),
);

function PageLoader() {
  return null;
}

function withSuspense(element: ReactNode) {
  return <Suspense fallback={<PageLoader />}>{element}</Suspense>;
}

export const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: withSuspense(<LoginPage />),
      },
    ],
  },
  {
    element: <AdminLayout />,
    children: [
      {
        path: ROUTES.DASHBOARD,
        element: withSuspense(<DashboardPage />),
      },
      {
        path: ROUTES.USERS,
        element: withSuspense(<UsersPage />),
      },
      {
        path: ROUTES.LOGS,
        element: withSuspense(<LogsPage />),
      },
      {
        path: ROUTES.STAFF,
        element: withSuspense(<StaffPage />),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={ROUTES.DASHBOARD} replace />,
  },
]);
